import { render, staticRenderFns } from "./DadosProcessadosBarra.vue?vue&type=template&id=3b90af63&scoped=true&"
import script from "./DadosProcessadosBarra.vue?vue&type=script&lang=js&"
export * from "./DadosProcessadosBarra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b90af63",
  null
  
)

export default component.exports